import React from 'react';
import { Alert, Button } from 'antd';
import { useVersionCheck } from '../reducers/use-version-check';

export const VersionWarningBanner: React.FC = () => {
	const { isStale, dismiss } = useVersionCheck();

	if (!isStale) return null;

	// Relies on index.html being served with Cache-Control: no-cache so the
	// reload pulls the fresh entry point (which references the new hashed bundle).
	const refresh = () => window.location.reload();

	return (
		<Alert
			banner
			closable
			type="warning"
			message="Dostępna jest nowsza wersja aplikacji. Odśwież stronę, aby ją załadować."
			afterClose={dismiss}
			action={
				<Button size="small" type="primary" onClick={refresh} style={{ marginRight: 16 }}>
					Odśwież
				</Button>
			}
			style={{ fontSize: 16, padding: '12px 16px' }}
		/>
	);
};
